import { defineMessages } from 'react-intl';

export const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	expandBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	collapseBodyContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	successPill: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	queuesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyQueuesDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.card-title',
		defaultMessage: 'Create priority group',
		description: 'Card title when creating a JSM queue group',
	},
	confirmButton: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.confirm-button',
		defaultMessage: 'Create',
		description: 'Label for the confirm button when creating a JSM queue group',
	},
	expandBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.expand-body-content',
		defaultMessage: 'Show more',
		description:
			'Button label to expand the card content area when text exceeds the visible height',
	},
	collapseBodyContent: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.collapse-body-content',
		defaultMessage: 'Show less',
		description:
			'Button label to collapse the card content area after it was expanded for long text',
	},
	successPill: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.success-pill',
		defaultMessage: `You've created "{name}" group`,
		description:
			'Pill message shown after create JSM queue group succeeds; name is the queue group name',
	},
	queuesLabel: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.queues-label',
		defaultMessage: 'Add queues',
		description: 'Label for the list of queues in the create queue group card body',
	},
	emptyQueuesDescription: {
		id: 'ai-mate.conversation-assistant-message-actions.create-queue-group.empty-queues-description',
		defaultMessage: 'Once created, add queues to help your team stay focused on critical work.',
		description:
			'Message shown in the create queue group card when no queues will be added initially.',
	},
});
